import{unstable_ownerDocument as _0x4cb78a}from'@mui/utils';export default _0x4cb78a;